import * as types from './mutation-types'

export const fetchBundles = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/bundles/collection').then((response) => {
            commit(types.SET_BUNDLES, response.data.bundles)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeBundle = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/bundle', payload).then((response) => {
            commit(types.ADD_BUNDLE, response.data.bundle)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateBundle = ({ commit }, { id, payload }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/${id}/bundle`, payload).then((response) => {
            commit(types.UPDATE_BUNDLE, response.data.bundle)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const uploadImage = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('bundle/upload-image', data).then((response) => {
            commit(types.SET_IMAGE, { id: response.data.id, image: response.data.image })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteBundle = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/${id}/bundle`).then((response) => {
            commit(types.DELETE_BUNDLE, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchShopBundles = ({ commit }, shopId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/shop/${shopId}/bundles`).then((response) => {
            commit(types.SET_SHOP_BUNDLES, response.data.shop_bundles)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeShopBundle = ({ commit }, { shopId, payload }) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/shop/${shopId}/bundle`, payload).then((response) => {
            commit(types.ADD_SHOP_BUNDLE, response.data.shop_bundle)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateShopBundlePrice = ({ commit }, { shopBundleId, payload }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/shop-bundle/${shopBundleId}/price`, payload).then((response) => {
            commit(types.UPDATE_SHOP_BUNDLE, response.data.shop_bundle)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteShopBundle = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/shop-bundle/${id}`).then((response) => {
            commit(types.DELETE_SHOP_BUNDLE, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const computeDefaultPrice = (_, { bundleId, shopId }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/bundle/${bundleId}/shop/${shopId}/default-price`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateShopBundleItems = ({ commit }, { shopBundleId, payload }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/shop-bundle/${shopBundleId}/items`, payload).then((response) => {
            commit('UPDATE_SHOP_BUNDLE', response.data.shop_bundle)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchShopPseCollection = (_, shopId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/shop/${shopId}/bundles/pse-collection`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
